const WebinarVideoProvider = `
  fragment WebinarVideoProvider on WebinarVideoProvider {
    date
    providerType
    url
    videoDuration
  }
`
export default WebinarVideoProvider
